export class RecuperarSenhaConfirmarFormModel {
    constructor(
        public email: string = '',
        public senha: string = '',
        public confirmar: string = ''
    ){}
}